import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';
export interface NotifySuccessCommandProperties extends CommandProperties {
	message: string;
	requestUrl: string;
	action: string;
}
export const NotifySuccessCommand = createCommand<NotifySuccessCommandProperties, void>(
	'notify-success-command',
);
